import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=26084dc2&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\soiko\\Documents\\Projects\\game\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('26084dc2')) {
      api.createRecord('26084dc2', component.options)
    } else {
      api.reload('26084dc2', component.options)
    }
    module.hot.accept("./Login.vue?vue&type=template&id=26084dc2&", function () {
      api.rerender('26084dc2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Login.vue"
export default component.exports